import GwayAgenteAtualizacaoService from "@/services/GwayAgenteAtualizacaoService";

const executar = (promessa) =>
  promessa.then(
    (result) => Promise.resolve(result),
    (error) => Promise.reject(error.response.data)
  );

export const gwayAgenteAtualizacao = {
  namespaced: true,
  state: { configuracao: {} },
  actions: {
    getConfiguracaoGwayAgenteAtualizacao() {
      return executar(GwayAgenteAtualizacaoService.GetConfiguracao());
    },
    postReleaseGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.PostRelease(payload));
    },
    putReleaseGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.PutRelease(payload));
    },
    deleteReleaseGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.DeleteRelease(payload));
    },
    publicarReleaseGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.PublicarRelease(payload));
    },
    uploadInstaladorGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.UploadInstalador(payload));
    },
    postArquivoGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.PostArquivo(payload));
    },
    putArquivoGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.PutArquivo(payload));
    },
    deleteArquivoGwayAgenteAtualizacao(context, payload) {
      return executar(GwayAgenteAtualizacaoService.DeleteArquivo(payload));
    },
  },
  mutations: {},
};

export default gwayAgenteAtualizacao;
